var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-container"},[_c('div',{staticClass:"center-region"},[_c('img',{staticClass:"logo",staticStyle:{"zoom":"0.25"},attrs:{"src":require("../../public/img/logo1.png")}}),_c('div',{staticClass:"centered-text"},[_vm._v("心狗健康远程医疗")])])])
}]

export { render, staticRenderFns }